import CurrentPriceList from '../models/CurrentPriceList';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

export interface CurrentPriceListState extends ApiState {
  currentPriceList?: CurrentPriceList[] 
}

export default requestReducer<CurrentPriceListState>('CURRENT_PRICE_LIST')